import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { 
    UserIcon, 
    PhoneIcon, 
    EnvelopeIcon, 
    PaperAirplaneIcon 
} from '@heroicons/react/24/outline';
import axios from '../../axios';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import Select from 'react-select';
import { selectStyles } from '../../Utils/selectStyles';
import { Switch } from '@headlessui/react';
import notify from '../../Utils/notify';

const Edit = () => {
   const { userId } = useParams();
    const [usuario, setUsuario] = useState({
        name: "",
        email: "",
        phone: "",
        sucursales: [],
        rol: "",
        activo: false
    });
    const [sucursales, setSucursales] = useState([]);
    const [roles, setRoles] = useState([]);
    const [selectedRol, setSelectedRol] = useState(null);
    const [activo, setActivo] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        axios.get(`api/users/${userId}`)
            .then(res => {
                setUsuario(res.data);
                setActivo(res.data.activo);
                setSelectedRol(res.data.rol ? { value: res.data.rol.name, label: res.data.rol.name } : null);
            }).catch(e => { console.log(e, 'Error ') });

        axios.get('api/sucursals')
            .then(response => {
                setSucursales(response.data);
            }).catch(e => console.log("error", e));

        axios.get('api/roles')
            .then((res) => {
                setRoles(res.data);
            }).catch(e => console.log("error ", e));
    }, [userId]);

    const handleUpdate = (e) => {
        e.preventDefault();
        const loadingToast = notify.loading('Actualizando usuario...');
        
        axios.put(`api/users/${userId}`, { ...usuario, activo })
            .then(res => {
                notify.dismiss(loadingToast);
                notify.success('Usuario actualizado correctamente');
                setTimeout(() => {
                    navigate("/admin/usuarios");
                }, 1500);
            })
            .catch(e => {
                notify.dismiss(loadingToast);
                const message = e.response?.data?.message || 'Error al actualizar el usuario';
                notify.error(message);
                console.error("error", e);
            });
    };

    return (
        <div>
            <div className="container-admin-menu">
                <Breadcrumb />
            </div>
            <div className="container-admin-container">
                <div className="container-admin bg-white rounded-lg shadow-md">
                    <h5 className="p-5 text-xl font-bold text-gray-800">Editar usuario</h5>
                    <form onSubmit={handleUpdate} className="px-5 pb-5 space-y-5">
                        {/* Nombre */}
                        <div className="w-full">
                            <label htmlFor="name" className="block text-sm font-medium text-gray-600 mb-2">
                                Nombre *
                            </label>
                            <div className="flex items-center gap-3 border border-gray-300 rounded-lg h-12 px-4 bg-[#0033ff]/5 hover:border-[#0033ff] transition-colors duration-200">
                                <UserIcon className="h-5 w-5 text-gray-400 flex-shrink-0" />
                                <input
                                    id="name"
                                    type="text"
                                    className="flex-1 bg-transparent border-none outline-none text-gray-700"
                                    value={usuario.name}
                                    onChange={e => setUsuario({ ...usuario, name: e.target.value })}
                                    required
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                            {/* Teléfono */}
                            <div>
                                <label htmlFor="phone" className="block text-sm font-medium text-gray-600 mb-2">
                                    Teléfono
                                </label>
                                <div className="flex items-center gap-3 border border-gray-300 rounded-lg h-12 px-4 bg-[#0033ff]/5 hover:border-[#0033ff] transition-colors duration-200">
                                    <PhoneIcon className="h-5 w-5 text-gray-400 flex-shrink-0" />
                                    <input
                                        id="phone"
                                        type="number"
                                        className="flex-1 bg-transparent border-none outline-none text-gray-700"
                                        value={usuario.phone}
                                        onChange={e => setUsuario({ ...usuario, phone: e.target.value })}
                                    />
                                </div>
                            </div>

                            {/* Email */}
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-600 mb-2">
                                    Email *
                                </label>
                                <div className="flex items-center gap-3 border border-gray-300 rounded-lg h-12 px-4 bg-[#0033ff]/5 opacity-60 hover:border-[#0033ff] transition-colors duration-200">
                                    <EnvelopeIcon className="h-5 w-5 text-gray-400 flex-shrink-0" />
                                    <input
                                        id="email"
                                        type="email"
                                        className="flex-1 bg-transparent border-none outline-none text-gray-700 cursor-not-allowed"
                                        value={usuario.email}
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                            {/* Sucursal - React Select Multiple */}
                            <div>
                                <label className="block text-sm font-medium text-gray-600 mb-2">
                                    Sucursal *
                                </label>
                                <Select
                                    isMulti
                                    options={[
                                        { value: 'todas', label: '✓ Todas las sucursales', isFixed: true },
                                        ...sucursales.map(s => ({ value: s.id, label: s.nombre_sucursal }))
                                    ]}
                                    value={(() => {
                                        const todasLasSucursales = sucursales.map(s => s.id);
                                        const tieneTodasSeleccionadas = usuario.sucursales.length === sucursales.length && sucursales.length > 0;
                                        
                                        if (tieneTodasSeleccionadas) {
                                            return [{ value: 'todas', label: '✓ Todas las sucursales', isFixed: true }];
                                        }
                                        
                                        return usuario.sucursales.map(id => {
                                            const suc = sucursales.find(s => s.id === id);
                                            return suc ? { value: suc.id, label: suc.nombre_sucursal } : null;
                                        }).filter(Boolean);
                                    })()}
                                    onChange={options => {
                                        const tieneOpcionTodas = options.some(o => o.value === 'todas');
                                        const teniaOpcionTodas = usuario.sucursales.length === sucursales.length && sucursales.length > 0;
                                        
                                        if (tieneOpcionTodas && !teniaOpcionTodas) {
                                            // Se seleccionó "Todas"
                                            setUsuario({ ...usuario, sucursales: sucursales.map(s => s.id) });
                                        } else if (!tieneOpcionTodas && teniaOpcionTodas) {
                                            // Se deseleccionó "Todas"
                                            const soloSucursalesReales = options.filter(o => o.value !== 'todas').map(o => o.value);
                                            setUsuario({ ...usuario, sucursales: soloSucursalesReales });
                                        } else if (!tieneOpcionTodas) {
                                            // Selección normal sin "Todas"
                                            setUsuario({ ...usuario, sucursales: options.map(o => o.value) });
                                        }
                                    }}
                                    placeholder="Seleccione una sucursal"
                                    classNamePrefix="react-select"
                                    styles={selectStyles}
                                />
                            </div>

                            {/* Rol - Select nativo estilizado */}
                            <div>
                                <label htmlFor="rol" className="block text-sm font-medium text-gray-600 mb-2">
                                    Rol *
                                </label>
                                <select
                                    id="rol"
                                    className="dento-input w-full bg-[#0033ff]/5 browser-default h-12 px-4 rounded-lg border border-gray-300 hover:border-[#0033ff] transition-colors duration-200"
                                    value={usuario.rol}
                                    onChange={e => setUsuario({ ...usuario, rol: e.target.value })}
                                    required
                                >
                                    <option value="" disabled>Seleccione un rol de usuario</option>
                                    {roles.map(item => (
                                        <option key={item.id} value={item.name}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Activo - Headless UI Switch */}
                        <div className="flex items-center gap-3 py-2">
                            <label className="text-sm font-medium text-gray-600">
                                Estado del usuario:
                            </label>
                            <Switch
                                checked={activo}
                                onChange={checked => {
                                    setActivo(checked);
                                    setUsuario({ ...usuario, activo: checked });
                                }}
                                className={`${
                                    activo ? 'bg-[#11cdef]' : 'bg-gray-300'
                                } relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-[#0033ff] focus:ring-offset-2`}
                            >
                                <span className="sr-only">Activar usuario</span>
                                <span
                                    className={`${
                                        activo ? 'translate-x-6' : 'translate-x-1'
                                    } inline-block h-4 w-4 transform rounded-full bg-white shadow-lg transition-transform duration-200 ease-in-out`}
                                />
                            </Switch>
                            <span className={`text-sm font-semibold ${activo ? 'text-[#11cdef]' : 'text-gray-500'}`}>
                                {activo ? 'Activo' : 'Inactivo'}
                            </span>
                        </div>

                        {/* Submit Button */}
                        <div className="pt-6 flex justify-end gap-3 border-t border-gray-200">
                            <button 
                                type="button"
                                onClick={() => navigate("/admin/usuarios")}
                                className="px-6 py-2 rounded-md uppercase font-bold text-sm bg-gray-100 text-gray-600 hover:bg-gray-200 transition-all duration-300 cursor-pointer"
                            >
                                Cancelar
                            </button>
                            <button 
                                type="submit"
                                className="bg-[#0033ff] text-white px-6 py-2 rounded-md uppercase font-bold text-sm border-2 border-[#0033ff] hover:bg-white hover:text-[#0033ff] hover:shadow-[0_0_15px_0_rgba(0,51,255,1)] transition-all duration-300 inline-flex items-center gap-2 cursor-pointer"
                            >
                                Actualizar
                                <PaperAirplaneIcon className="h-5 w-5" />
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Edit;